import React from 'react';
import { Eye } from 'phosphor-react';

// GENI Brain logo fallback for avatars
const GENI_BRAIN_FALLBACK = "https://customer-assets.emergentagent.com/job_chart-analyzer-107/artifacts/gtg4vc6a_purebrain.png";

/**
 * CompactProfileHeader
 * 
 * A minimal identity header for internal public profile pages (Analytics, Trades, About).
 * Shows only avatar + name to avoid duplicating the full Trading Performance summary.
 * 
 * The full ProfileSummaryHeader is shown ONLY on the Overview page.
 * 
 * Props:
 * - username: string - profile display name
 * - avatarUrl: string - custom avatar URL (optional)
 */
export default function CompactProfileHeader({ username, avatarUrl }) {
  const displayName = username || 'Trader';
  const profileAvatarUrl = avatarUrl || null;

  return (
    <div className="flex items-center gap-4 mb-6" data-testid="compact-profile-header">
      {/* Small Avatar */}
      <div 
        className="w-12 h-12 rounded-full overflow-hidden border border-white/20 bg-[#121212] flex-shrink-0"
        data-testid="compact-profile-avatar"
      >
        <img
          src={profileAvatarUrl || GENI_BRAIN_FALLBACK}
          alt={`${displayName}'s avatar`}
          className="w-full h-full object-cover"
          onError={(e) => {
            e.target.src = GENI_BRAIN_FALLBACK;
          }}
        />
      </div>
      
      {/* Name + Indicator */}
      <div>
        <h2 className="text-lg font-bold text-white">{displayName}</h2>
        <div className="flex items-center gap-1.5">
          <Eye size={12} weight="bold" className="text-white/40" />
          <span className="text-white/40 text-xs">Verified trading journal</span>
        </div>
      </div>
    </div>
  );
}
